import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getVatTypesKey } from '../../utils/keys';
export const useVatTypes = (options) => {
    const { useQueryOptions } = options || {};
    const { client } = useTribeClient();
    const vatTypesKey = getVatTypesKey();
    return useQuery(vatTypesKey, () => client.billing.vatTypes(), {
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useVatTypes.js.map